module.exports = __webpack_public_path__ + "static/media/fss.3aec600a.png";